module.exports = __webpack_public_path__ + "static/img/exercise-6.5876f1b.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/exercise-6.png
// module id = YtKI
// module chunks = 1